import { createInjectionState } from "@vueuse/core";
import { useContextOrThrow } from "ls/composables/useContextOrThrow";
import { ref } from "vue";

const [useProvideDocumentCommandContext, useDocumentCommandContextFn] = createInjectionState(() => {
  const isBrowseAiButtons = ref(false);
  const isBrowseSections = ref(false);

  return {
    isBrowseAiButtons,
    isBrowseSections,
  };
});

export { useProvideDocumentCommandContext };
export const useDocumentCommandContext = useContextOrThrow(useDocumentCommandContextFn);
